module.exports = __webpack_public_path__ + "img/u6.dfb7f57d.png";